import React, { useEffect } from 'react'
import Plyr from 'plyr';

import CloseIcon from '../../i/icons/close.svg';
import SVGSprite from '../../i/sprite/sprite.svg';

export const StreamVideoPopup = ({ hidePopup }) => {

	useEffect(() => {
		const videoPlayer = new Plyr('#player', {
			iconUrl: { SVGSprite },
			invertTime: false,
			hideControls: false
		});
	}, []);

	return (
		<div className="popup popupStreamVideo">
			<div className="popup_in">
				<button className="btn_close btnCloseStreamVideo">
					<CloseIcon
						className="icon icon-close white_mod size_mod"
						onClick={hidePopup}
					/>
				</button>
				<div className="popup_video">
					<div id="player" className="video_block" data-plyr-provider="youtube" data-plyr-embed-id="bTqVqk7FSmY"></div>
				</div>
			</div>
		</div>
	);
}
export default StreamVideoPopup;